import React, { useEffect } from 'react';
import { Row } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import CustomTitleWithInput from 'components/base/CustomTitleWithInput';
import { ReactHookFormErrorMessage } from 'components/base/ErrorFieldMessage';
import { AdminGroupErrorHandleFields } from 'containers/admin/adminGroups/AdminGroupErrorHandleFields';
import BaseEditSection from 'containers/base/BaseEditSection';
import CustomRadios from 'components/base/CustomRadios';
import { ADMIN_PERMISSION_TYPE, DISPLAY_PERMISSION_TYPE } from 'config/CustomEnums';
import { createAction } from 'utils';

const mapPropsToState = (state) => ({
  allPermissions: state.admin.allPermissionList, // state.admin.cmsAllPermissions,
});
function CreateAdminGroupStepOneGeneralSection({ allPermissions }) {
  const { watch, setValue, control, formState: { errors } } = useFormContext();
  const dispatch = useDispatch();
  const params = useParams();
  const isEditMode = Boolean(params?.id)
  const watchName = watch('name');
  const watchPermissions = watch('permissions') || [];
  const permissionTypeField = "permissionType";
  const watchPermissionType = watch(permissionTypeField);

  useEffect(() => {
    if (!isEditMode) {
      setValue(permissionTypeField, ADMIN_PERMISSION_TYPE.CMS_ADMIN_PERMISSON, { shouldDirty: true, })
    }
    return () => {
      dispatch(createAction("admin/updateState")({
        allPermissionList: []
      }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=>{
    if (watchPermissionType) {
      dispatch(createAction('admin/getAllPermissions')({
        isMerchant: watchPermissionType === ADMIN_PERMISSION_TYPE.MERCHANT_ADMIN_PERMISSON
      }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchPermissionType])

  return (
    <>
      <BaseEditSection
        title="INFORMATION"
        fields={[
          <Controller
            control={control}
            name="name"
            rules={{ required: AdminGroupErrorHandleFields.name.required }}
            render={() => (
              <CustomTitleWithInput
                title={'Name'}
                defaultValue={watchName}
                setValue={(value) => {
                  setValue('name', value, {
                    shouldDirty: true,
                  });
                }}
              />
            )}
          />,
          <label
            className={`create-section-label create-section-label-bottom-space`}
          >
            {"Permission type (Optional)"}
          </label>,
          <Controller
            control={control}
            name={permissionTypeField}
            render={() => (
              <Row style={{ margin: 0 }}>
                <CustomRadios
                  onChange={(value) => {
                    setValue(permissionTypeField, value, { shouldDirty: true });
                  }}
                  default={watchPermissionType}
                  options={Object.values(ADMIN_PERMISSION_TYPE)?.map((item) => ({
                    label: DISPLAY_PERMISSION_TYPE?.[item] || "-",
                    value: item,
                  }))}
                />
              </Row>
            )}
          />,
          <ReactHookFormErrorMessage errors={errors} id="name" />,
          <Controller
            control={control}
            name="permissions"
            render={() => (
              <BaseMultipleSelectorV2
                title={'Assign permissions(optional)'}
                tips={
                  'The word “Edit” in below permission items covered create, edit, delete, duplicate permission; while for edit campaign and edit message permissions, they only covered delete and duplicate, create and edit has separate permissions.'
                }
                namespace="admin"
                groupKey="groupKey"
                data={{
                  sourceData: allPermissions,
                  targetData: watchPermissions,
                  targetChange: (value) => {
                    console.log('targetChange @65', value);
                    setValue('permissions', value, {
                      shouldDirty: true,
                    });
                  },
                }}
              />
            )}
          />,
          <ReactHookFormErrorMessage errors={errors} id="permissions" />,
        ]}
      />
    </>
  );
}

export default connect(mapPropsToState)(CreateAdminGroupStepOneGeneralSection);
